import React from 'react'
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui'

const TimeIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M12.0951 5.90375C16.0446 5.90375 19.2465 9.10566 19.2465 13.0552C19.2465 16.4463 16.8683 19.3463 13.6049 20.0468C13.6076 20.0456 13.6355 21.0202 13.6355 21.0202C17.426 20.2914 20.2065 16.9607 20.2065 13.0552C20.2065 8.57547 16.5748 4.94375 12.0951 4.94375V5.90375Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.2257 13.0551C14.2257 14.0668 13.5207 14.9141 12.5751 15.1319V21.0952H11.6151V15.132C10.6694 14.9143 9.96422 14.0669 9.96422 13.0551C9.96422 11.8782 10.9181 10.9243 12.095 10.9243C13.2718 10.9243 14.2257 11.8782 14.2257 13.0551ZM13.2657 13.0551C13.2657 12.4084 12.7416 11.8843 12.095 11.8843C11.4483 11.8843 10.9242 12.4084 10.9242 13.0551C10.9242 13.7019 11.4484 14.2263 12.095 14.2263C12.7415 14.2263 13.2657 13.7019 13.2657 13.0551Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0249 0H9.16534C8.90025 0 8.68534 0.214903 8.68534 0.48C8.68534 0.745097 8.90025 0.96 9.16534 0.96H11.6152V2.41061C9.41683 2.50804 7.39161 3.27164 5.73651 4.50445L4.94352 3.49983L4.18998 4.09462L4.99299 5.11194C2.81236 7.06301 1.43994 9.89879 1.43994 13.0551C1.43994 18.9397 6.21053 23.7106 12.095 23.7106C17.9795 23.7106 22.7501 18.9397 22.7501 13.0551C22.7501 9.83717 21.3236 6.95241 19.0684 4.99869L19.8782 3.9728L19.1246 3.378L18.3154 4.40326C16.6864 3.22998 14.7126 2.50543 12.5752 2.41063V0.96H15.0249C15.29 0.96 15.5049 0.745097 15.5049 0.48C15.5049 0.214903 15.29 0 15.0249 0ZM12.095 3.36C17.4494 3.36 21.7901 7.7007 21.7901 13.0551C21.7901 18.4095 17.4493 22.7506 12.095 22.7506C6.74074 22.7506 2.39994 18.4095 2.39994 13.0551C2.39994 7.7007 6.74064 3.36 12.095 3.36Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default TimeIcon
